/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2026-03-25 10:28:56
 * @LastEditors: 聂章帅
 * @LastEditTime: 2026-03-25 10:36:00
 */
// 图片加载工具函数
// 支持两种路径格式:
// 1. "/images/xxx.png" - 从 public 目录加载（打包后可配置）
// 2. "xxx.png" - 从 assets 目录加载（webpack打包）
export function getImageUrl(imageName) {
  if (!imageName) return ''
  
  // 如果是 /images/ 开头，直接使用 public 目录路径（打包后可配置）
  if (imageName.startsWith('/images/')) {
    return imageName
  }
  
  try {
    return require(`@/assets/images/${imageName}`)
  } catch (e) {
    console.warn(`图片未找到: ${imageName}`, e)
    return ''
  }
}

// 批量处理配置中的图片路径
export function processConfigImages(config) {
  if (!config) return config
  
  const processed = { ...config }
  
  // 处理背景图片
  if (processed.backgroundImage) {
    processed.backgroundImage = getImageUrl(processed.backgroundImage)
  }
  
  // 处理App图片
  if (processed.appImage) {
    processed.appImage = getImageUrl(processed.appImage)
  }
  
  // 处理linkList中的图片
  if (processed.linkList && Array.isArray(processed.linkList)) {
    processed.linkList = processed.linkList.map(item => {
      const newItem = { ...item }
      if (newItem.src) {
        newItem.src = getImageUrl(newItem.src)
      }
      if (newItem.backGround) {
        newItem.backGround = getImageUrl(newItem.backGround)
      }
      return newItem
    })
  }
  
  return processed
}
